import { default as Container } from './ShopReportsPageContent.container';
import { default as Component } from './ShopReportsPageContent';
export default Container(Component);
